var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"settings-form-item",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"item-label"},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"item-action"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }